import type {
  MealEntity,
  MealPropsPub,
  MealPropsPvt,
} from './entity/mealEntity';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { MealJsonPub, MealJsonPvt } from '@/types/domain/meal/entities/mealEntity';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * 食事ドメインサービス(施設)
 */
export class MealNurseryDomainService extends DomainServiceBase {
  private wagakoNurseryApi!: WagakoNurseryIApi;

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   */
  public inject(
    wagakoNurseryApi: WagakoNurseryIApi,
  ) {
    this.wagakoNurseryApi = wagakoNurseryApi;
  }

  /**
   * sendNurseryMeal
   * @param entity entity
   */
  async sendNurseryMeal(
    entity: MealEntity,
  ) {
    await this.wagakoNurseryApi.send<
      MealPropsPvt,
      MealJsonPvt,
      MealPropsPub,
      MealJsonPub
    >(entity);
  }

  /**
   * removeNurseryMeal
   * @param entity entity
   */
  async removeNurseryMeal(
    entity: MealEntity,
  ) {
    await this.wagakoNurseryApi.remove<
      MealPropsPvt,
      MealJsonPvt,
      MealPropsPub,
      MealJsonPub
    >(entity);
  }
}
